<div class="service__info--box" >
    <p style="margin: 0%;">{{ contactNo}}</p>
    <div>
        <a href="tel:{{contactNo}}{{openUrl}}">
            <img class="service-image mr-2" src="assets/img/phonebutton.png" alt="" width="85" height="40">
        </a>         
        <a [href]="'viber://chat?number='+viberNo+''+openUrl | safeUrl" *ngIf="isIOS==false && isShowViber" >
            <img class="service-image" src="assets/img/viberbutton.png" alt=""  width="85" height="40">
        </a>
        <a [href]="'viber://chat?number='+contactNo+''+openUrl | safeUrl" *ngIf="isIOS==true && isShowViber"  >
            <img class="service-image" src="assets/img/viberbutton.png" alt="" width="85" height="40">
        </a>
    </div>
</div>
